import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AdminAddCustomer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const user = JSON.parse(localStorage.getItem('user'));
  const adminEmail = user ? user.email : '';

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    gender: '',
    storeName: '',
    storeType: '',
    state: '',
    lga: '',
    city: '',
    storeAddress: '',
    locality: '',
    gpsCode: '',
    potentialpurchase: '',
    customerclass: '',
    fieldagent: adminEmail,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let customerclass = '';
    switch (formData.potentialpurchase) {
      case '₦50,000 - ₦75,000':
        customerclass = 'Tier 4';
        break;
      case '₦75,000 - ₦100,000':
        customerclass = 'Tier 3';
        break;
      case '₦100,000 - ₦200,000':
        customerclass = 'Tier 2';
        break;
      case 'Above ₦200,000':
        customerclass = 'Tier 1';
        break;
      default:
        toast.error('Invalid potential purchase value');
        setLoading(false);
        return;
    }

    const dataToSend = {
      ...formData,
      customerclass,
    };

    try {
      const response = await fetch('https://citi-mobile-app.onrender.com/saleagent/customers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();
      if (response.ok) {
        toast.success('Customer added successfully');
        setTimeout(() => navigate(-1), 2000);
      } else {
        toast.error(result.message || 'Error adding customer');
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="p-4 md:p-6 md:ml-60 mt-5">
      <ToastContainer position="top-right" autoClose={3000} />
      
      <button onClick={handleBack} className="mb-4 flex items-center">
        <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
        <span>Add A Customer</span>
      </button>

      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-4 md:px-8 pt-6 pb-8 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="firstName">
              First Name
            </label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              placeholder="First Name"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lastName">
              Last Name
            </label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              placeholder="Last Name"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="phoneNumber">
              Phone Number
            </label>
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              placeholder="Phone Number"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="gender">
              Gender
            </label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="storeName">
              Store Name
            </label>
            <input
              type="text"
              name="storeName"
              value={formData.storeName}
              placeholder="Store Name"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="storeType">
              Store Type
            </label>
            <select
              name="storeType"
              value={formData.storeType}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            >
              <option value="">Select Store Type</option>
              <option value="Neighbourhood Store">Neighbourhood Store</option>
              <option value="Convenience Store">Convenience Store</option>
              <option value="Supermarket">Supermarket</option>
              <option value="Kiosk">Kiosk</option>
              <option value="Wholesaler">Wholesaler</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="state">
              State
            </label>
            <input
              type="text"
              name="state"
              value={formData.state}
              placeholder="State"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lga">
              Local Government Area
            </label>
            <input
              type="text"
              name="lga"
              value={formData.lga}
              placeholder="Local Government Area"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="city">
              City
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              placeholder="City"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="storeAddress">
              Store Address
            </label>
            <input
              type="text"
              name="storeAddress"
              value={formData.storeAddress}
              placeholder="Store Address"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="locality">
              Locality/Area
            </label>
            <input
              type="text"
              name="locality"
              value={formData.locality}
              placeholder="Locality/Area"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="gpsCode">
              GPS Code (Plus Code)
            </label>
            <input
              type="text"
              name="gpsCode"
              value={formData.gpsCode}
              placeholder="GPS Code"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="potentialpurchase">
              Potential Weekly Purchase
            </label>
            <select
              name="potentialpurchase"
              value={formData.potentialpurchase}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            >
              <option value="">Select Potential Weekly Purchase</option>
              <option value="₦50,000 - ₦75,000">₦50,000 - ₦75,000</option>
              <option value="₦75,000 - ₦100,000">₦75,000 - ₦100,000</option>
              <option value="₦100,000 - ₦200,000">₦100,000 - ₦200,000</option>
              <option value="Above ₦200,000">Above ₦200,000</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fieldagent">
              Assign Agent
            </label>
            <input
              type="text"
              name="fieldagent"
              value={formData.fieldagent}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full bg-gray-100"
              readOnly
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              placeholder="Password"
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
              required
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-6">
          <button
            type="button"
            onClick={handleBack}
            className="w-full md:w-auto bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="w-full md:w-auto bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                <span>Saving...</span>
              </>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminAddCustomer;